import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import banner6 from "../assets/banner6.jpg";
import banner7 from "../assets/banner7.jpg";
import banner8 from "../assets/banner8.jpg";
import { MdOutlineArrowOutward, MdVerified } from "react-icons/md";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [bgIndex, setBgIndex] = useState(0);
  const banners = [banner2, banner6, banner7, banner8, banner1, banner5, banner3, banner4];

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 2800);
    return () => clearInterval(interval);
  }, [banners.length]);

  const bullets = [
    "Tailored supply: Materials curated to match project-specific requirements",
    "Reliable delivery: Coordinated transport that keeps timelines on track",
    "Clear communication: Transparent updates from start to finish",
    "Technical guidance: Practical support to help teams choose the right solutions",
    "Responsive service: Fast, attentive support whenever challenges arise",
    "Proven dependability: Consistent performance trusted by contractors and institutions",
  ];

  return (
    <div className="modern-banner-one">
      <div className="modern-banner-one-bg">
        {banners.map((banner, i) => (
          <div
            key={i}
            className="modern-banner-one-layer"
            style={{
              backgroundImage: `url(${banner})`,
              opacity: i === bgIndex ? 1 : 0,
            }}
          />
        ))}
      </div>

      <div className="modern-banner-one-overlay">
        <div className="container modern-banner-one-container">
          <div className="modern-banner-one-shell">
            <div className="modern-banner-one-grid">
              <div
                className="modern-banner-one-main"
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-offset="140"
              >
                <h1 className="modern-banner-one-title">Reliable materials, efficient delivery, Innovative Outcomes</h1>
                <p className="modern-banner-one-text">
                  We support contractors, developers, institutions, and homeowners across Tanzania with curated
                  building materials, coordinated transport and clear communication from quotation to fulfillment
                  ensuring every project runs smoothly.
                </p>

                <div className="modern-banner-one-actions">
                  <button
                    className="btn btn-padded btn-rounded btn-primary"
                    onClick={() => appContext.navTo({ item: "about_us" })}
                  >
                    About Us <MdOutlineArrowOutward size={18} />
                  </button>
                  <button
                    className="btn btn-padded btn-rounded btn-outline-light"
                    onClick={() => appContext.navTo({ item: "request_quote" })}
                  >
                    Request Quote
                  </button>
                </div>
              </div>

              <div
                className="modern-banner-one-card"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="140"
              >
                <h6 className="modern-banner-one-card-title">Why teams choose us</h6>
                {bullets.map((item, index) => (
                  <div key={index} className="modern-banner-one-bullet">
                    <MdVerified size={16} className="flex-shrink-0 modern-bullet-icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .modern-banner-one {
          min-height: calc(100vh - var(--topBarHeight));
          position: relative;
          overflow: hidden;
          font-family: "FontRegular", "Segoe UI", sans-serif;
        }

        .modern-banner-one-bg,
        .modern-banner-one-overlay {
          position: absolute;
          inset: 0;
        }

        .modern-banner-one-layer {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          transition: opacity 1.1s ease;
        }

        .modern-banner-one-overlay {
          background: linear-gradient(108deg, rgba(6, 20, 38, 0.8), rgba(8, 32, 60, 0.54));
          display: flex;
          align-items: center;
          z-index: 1;
          padding: 24px 0;
        }

        .modern-banner-one-container {
          width: 100%;
        }

        .modern-banner-one-shell {
          max-width: 1140px;
          margin: 0 auto;
          border: 1px solid rgba(255, 255, 255, 0.16);
          border-radius: 20px;
          background: rgba(8, 24, 43, 0.4);
          box-shadow: 0 18px 34px rgba(9, 27, 48, 0.26);
          backdrop-filter: blur(4px);
          padding: 20px;
        }

        .modern-banner-one-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
          align-items: stretch;
        }

        .modern-banner-one-main,
        .modern-banner-one-card {
          border-radius: 14px;
          border: 1px solid rgba(255, 255, 255, 0.16);
          background: rgba(255, 255, 255, 0.08);
          padding: 20px;
        }

        .modern-banner-one-eyebrow {
          color: #99ddff;
          font-size: 12px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          margin-bottom: 8px;
        }

        .modern-banner-one-title {
          color: #ffffff;
          font-size: clamp(28px, 3.3vw, 42px);
          line-height: 1.12;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          margin-bottom: 10px;
        }

        .modern-banner-one-text {
          color: rgba(241, 247, 253, 0.94);
          font-size: 16px;
          line-height: 1.78;
          margin-bottom: 18px;
          max-width: 620px;
        }

        .modern-banner-one-actions {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .modern-banner-one-card-title {
          color: #ffffff;
          font-size: 20px;
          line-height: 1.3;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          margin-bottom: 12px;
        }

        .modern-banner-one-bullet {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: rgba(242, 248, 254, 0.94);
          margin-bottom: 9px;
          font-size: 16px;
          line-height: 1.6;
        }

        .modern-bullet-icon {
          margin-top: 2px;
          color: #97d9ff;
        }

        .modern-banner-one-chip-row {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 12px;
        }

        .modern-banner-one-chip {
          background: rgba(255, 255, 255, 0.12);
          color: #ffffff;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 999px;
          padding: 6px 12px;
          font-size: 12px;
          letter-spacing: 0.4px;
        }

        @media (max-width: 991px) {
          .modern-banner-one-shell {
            border-radius: 18px;
            padding: 16px;
          }

          .modern-banner-one-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 767px) {
          .modern-banner-one {
            min-height: auto;
            overflow: hidden;
          }

          .modern-banner-one-overlay {
            position: relative;
            min-height: calc(100vh - var(--topBarHeight));
            padding: 12px 0 16px;
            align-items: center;
          }

          .modern-banner-one-container {
            padding-top: 4px;
            padding-bottom: 4px;
          }

          .modern-banner-one-shell {
            padding: 14px;
          }

          .modern-banner-one-main,
          .modern-banner-one-card {
            padding: 18px;
            border-radius: 14px;
          }

          .modern-banner-one-title {
            font-size: 22px;
          }
        }
      `}</style>
    </div>
  );
}
